import { useEffect, useState } from "react";
import HeaderTarifs from "./HeaderTarifs";
import RatePlanGrid from "./RatePlanGrid/RatePlanGrid";
import RatePlansDrawer from "./RatePlansDrawer";
import axios from "axios";
import { useParams } from "react-router-dom";
import { TbX } from "react-icons/tb";

const API = "https://api.komorotel.com/api";

const TarifsPage = ({ needRatePlanMsg, setNeedRatePlanMsg, setActivePage }) => {
  const { hotelId } = useParams();
  const [rooms, setRooms] = useState([]);
  const [ratePlans, setRatePlans] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [editingRatePlan, setEditingRatePlan] = useState(null);
  const [ratePrices, setRatePrices] = useState([]);

  useEffect(() => {
    axios.get(`${API}/rooms/hotel/${hotelId}`)
      .then((res) => setRooms(res.data))
      .catch(console.error);
  }, [hotelId]);

  useEffect(() => {
    axios.get(`${API}/rateplans/hotel/${hotelId}`)
      .then((res) => setRatePlans(res.data))
      .catch(console.error);
  }, [hotelId]);

  const closeDrawer = () => {
    setShowDrawer(false);
    setEditingRatePlan(null);
    setRatePrices([]);
  };

  const handleCreateRatePlan = async (payload) => {
    try {
      const res = await axios.post(`${API}/rateplans`, payload, { withCredentials: true });
      setRatePlans((prev) => [...prev, res.data]);
      setActivePage("inventory");
      return res.data; // ← important pour que le drawer récupère l'_id
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdateRatePlan = async (ratePlanId, payload) => {
    try {
      const res = await axios.put(`${API}/rateplans/${ratePlanId}`, payload, { withCredentials: true });
      setRatePlans((prev) =>
        prev.map((plan) => plan._id === ratePlanId ? res.data : plan)
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteRatePlan = async (plan) => {
    try {
      await axios.delete(`${API}/rateplans/${plan._id}`, { withCredentials: true });
      setRatePlans((prev) => prev.filter((rp) => rp._id !== plan._id));
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = async (plan) => {
    setEditingRatePlan(plan);
    setRatePrices([]); // reset pendant le fetch

    try {
      // Fetch tous les RatePrices de ce ratePlan (toutes chambres)
      const res = await axios.get(`${API}/rateprices/rateplan/${plan._id}`, { withCredentials: true });
      setRatePrices(res.data);
    } catch (err) {
      console.error("Erreur fetch ratePrices :", err);
      // On ouvre quand même le drawer, juste sans pré-cocher
    }

    setShowDrawer(true);
  };

  return (
    <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col gap-8">

      {/* Banner */}
      {needRatePlanMsg && (
        <div className="flex items-start gap-3 px-4 py-3 bg-amber-50 border border-amber-200 rounded-xl">
          <span className="text-amber-500 text-lg shrink-0">⚡</span>
          <div className="flex-1">
            <p className="text-sm font-semibold text-amber-800">Disponibilité configurée !</p>
            <p className="text-xs text-amber-600 mt-0.5">
              Créez maintenant un tarif pour rendre votre chambre réservable.
            </p>
          </div>
          <button
            onClick={() => setNeedRatePlanMsg(false)}
            className="text-amber-400 hover:text-amber-600 transition"
          >
            <TbX className="text-base" />
          </button>
        </div>
      )}

      <HeaderTarifs openDrawer={() => setShowDrawer(true)} />

      <RatePlanGrid
        ratePlans={ratePlans}
        handleEdit={handleEdit}
        handleDelete={handleDeleteRatePlan}
      />

      <RatePlansDrawer
        show={showDrawer}
        onHide={closeDrawer}
        rooms={rooms}
        ratePrices={ratePrices}
        onCreate={handleCreateRatePlan}
        onUpdate={handleUpdateRatePlan}
        hotelId={hotelId}
        editingPlan={editingRatePlan}
      />
    </div>
  );
};

export default TarifsPage;